import type { ReactNode } from "react";

import { Chip } from "@nt/ui/chip";

/**
 * The signed-out screens' shell, the customer sign-in's layout
 * (apps/app/src/features/auth/ui/auth-layout.tsx) to the pixel: the wordmark
 * on the paper, a `type-h3` heading, and one white card on the card ring.
 * The one addition is the "Admin console" chip under the wordmark, so staff
 * can tell at a glance which app they are signing in to. The wordmark is a
 * copy of the app's `/logo-green.svg` in this app's `public/`, so no new
 * workspace edge is needed to show it.
 */
export function AuthLayout({
  title,
  subtitle,
  footer,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  /** Quiet meta under the card. */
  footer?: ReactNode;
  children: ReactNode;
}) {
  return (
    <main className="flex min-h-svh flex-col items-center justify-center bg-background px-4 py-12 sm:py-16">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center text-center">
          <img
            src="/logo-green.svg"
            alt="Nonresident Tax"
            width={493}
            height={40}
            className="h-5 w-auto"
          />
          <div className="mt-3 mb-8">
            <Chip tone="surface">Admin console</Chip>
          </div>
          <h1 className="type-h3 text-foreground">{title}</h1>
          {subtitle ? (
            <p className="mt-2 type-body text-body">{subtitle}</p>
          ) : null}
        </div>
        <div className="rounded-card bg-card p-6 shadow-card sm:p-8">
          {children}
        </div>
        {footer ? (
          <p className="mt-6 text-center text-sm text-muted-foreground">
            {footer}
          </p>
        ) : null}
      </div>
    </main>
  );
}
